import { React, useContext, useEffect, useState } from "react";
import { Navbar, Sidebar, IconBtn, Page } from "../components";
import { AuthContext } from "../context/auth";
import { searchBookbyBookId, searchBookbyTitle } from "../assets/Js/script";
import { Link as RouterLink, useNavigate } from "react-router-dom";

export default function SearchPage() {
  const { search, setSearch } = useContext(AuthContext);
  const [searchResult, setSearchResult] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    async function booksearch() {
      const { response, error } = await searchBookbyTitle(search);
      if (response.status === "success") {
        setSearchResult([...response.data.books]);
      }
    }

    if(search !== "") {
      booksearch();
    } 
    
    if(search === "") {
      setSearchResult([]);
    }
  }, [search]);
  console.log(searchResult)
  return (
    <Page active="Search Page">
      <Navbar />
      <div className="mx-4 flex justify-center flex-col">
        <h1 className="hidden lg:flex text-[22px] mb-8 font-bold ">
          Search Results for{" "}
          <span className="text-[20px] pl-2 font-semibold ">'{search}'</span>
        </h1>
        <div
          className={`hidden justify-between items-center w-full px-4 lg:px-0 lg:mb-0 mb-[3.5rem]`}
        >
          <h1 className="flex items-center text-mobile-h1 sm:text-tablet-h1 lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
            <span className=" lg:hidden mr-[18px]">
              <svg
                width="12"
                height="20"
                viewBox="0 0 12 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                  fill="#702963"
                />
              </svg>
            </span>
            Catalogue
          </h1>
          <div className="flex lg:hidden items-center">
            <button className="mr-5">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 2C0 1.60218 0.158036 1.22064 0.43934 0.93934C0.720645 0.658036 1.10218 0.5 1.5 0.5H16.5C16.8978 0.5 17.2794 0.658036 17.5607 0.93934C17.842 1.22064 18 1.60218 18 2C18 2.39782 17.842 2.77936 17.5607 3.06066C17.2794 3.34196 16.8978 3.5 16.5 3.5H1.5C1.10218 3.5 0.720645 3.34196 0.43934 3.06066C0.158036 2.77936 0 2.39782 0 2Z"
                  fill="#702963"
                />
                <path
                  d="M3 8C3 7.60218 3.15804 7.22064 3.43934 6.93934C3.72064 6.65804 4.10218 6.5 4.5 6.5H13.5C13.8978 6.5 14.2794 6.65804 14.5607 6.93934C14.842 7.22064 15 7.60218 15 8C15 8.39782 14.842 8.77936 14.5607 9.06066C14.2794 9.34196 13.8978 9.5 13.5 9.5H4.5C4.10218 9.5 3.72064 9.34196 3.43934 9.06066C3.15804 8.77936 3 8.39782 3 8Z"
                  fill="#702963"
                />
                <path
                  d="M7.5 12.5C7.10218 12.5 6.72064 12.658 6.43934 12.9393C6.15804 13.2206 6 13.6022 6 14C6 14.3978 6.15804 14.7794 6.43934 15.0607C6.72064 15.342 7.10218 15.5 7.5 15.5H10.5C10.8978 15.5 11.2794 15.342 11.5607 15.0607C11.842 14.7794 12 14.3978 12 14C12 13.6022 11.842 13.2206 11.5607 12.9393C11.2794 12.658 10.8978 12.5 10.5 12.5H7.5Z"
                  fill="#702963"
                />
              </svg>
            </button>
            <button className="mr-5">
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                  stroke="#702963"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <button>
              <svg
                width="28"
                height="24"
                viewBox="0 0 28 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.786 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0973 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11788 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                  fill="#702963"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="w-full lg:hidden rounded-full shadow-lg">
          <IconBtn>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 17L13.1333 13.1333M15.2222 8.11111C15.2222 12.0385 12.0385 15.2222 8.11111 15.2222C4.18375 15.2222 1 12.0385 1 8.11111C1 4.18375 4.18375 1 8.11111 1C12.0385 1 15.2222 4.18375 15.2222 8.11111Z"
                stroke="#702963"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconBtn>
        </div>
        <div className="relative flex w-full flex-col">
         {searchResult.length > 0 ? 
          searchResult.map((book, index) => (
            <div 
            onClick={() => {
              navigate(`/books/${book.parentId}`);
              setSearch('');
          }}
            key={book.parentId}
             className="hidden cursor-pointer lg:flex justify-between items-center w-full h-[125px] border-1 border-solid border-primary-dark-20 bg-[#fbfafb] mb-6">
            <div className="flex gap-3">
              <div
                className={`w-[100px] flex justify-center items-center  h-[125px]`}
                style={{backgroundColor: book.backgroundColor}}
              >
                <div
                
                 className="w-[75px] h-[100px] shadow-xl ">
                <img
                  className="h-full w-full object-cover "
                  src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/books/${book.imageCoverFront}`}
                  alt="front cover"
                />
                </div>
              </div>
              <div className="py-1 lg:w-fit w-[229px] lg:px-6 lg:py-4 flex flex-col  lg:justify-between">
                <p
                  className={`hidden lg:block text-secondary-light text-[14px] uppercase`}
                >
                  {book.bookIdString}
                </p>
                <p className=" leading-[22px] text-heading text-left font-semibold text-h5">
                  {book.title}
                </p>
                <p className="text-p1 mb-[20px] text-secondary-dark font-semibold">
                {book.Bauthors?.map(
                                      (auther , index , arr) => <span>{
                                        (arr.indexOf(arr[index]) === arr.length -1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                                        }</span>
                                    )}                  </p>
              </div>
            </div>
            {/* <p className="block mr-6 text-p1 font-semibold w-[183px] h-12">
              &#8377; {book.eBookPrice}
            </p> */}
             </div>
          ))
          : 
          <div
           className="hidden lg:flex justify-center items-center w-full h-[125px] border-1 border-solid border-primary-dark-20 bg-[#fbfafb] mb-6">
             <h3 className="text-[#383737] font-bold  ">
              No Book found with this title. Please try again...
             </h3>
          </div>
         }
          <div className="block lg:hidden mt-10 w-full">
            {searchResult.length > 0 ? 
            searchResult.map((book, index) => (<div className="w-full h-[109px] flex lg:block lg:w-[260px] lg:h-[351px] shadow-[4px_4px_4px_rgba(224,224,224,0.25)] rounded-sm border-1 border-solid border-primary-dark-20 scale-1 lg:hover:scale-105 lg:transition lg:duration-600 lg:hover:ease-in">
              <div
                              style={{backgroundColor: book.backgroundColor}}

                className={`flex justify-center items-center h-full w-[98px] lg:w-full lg:h-[70%] bg-[rgb(180,180,180)] relative`}
              >
                <img
                  className="h-full w-full object-cover "
                  src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/books/${book.imageCoverFront}`}
                  alt="front cover"
                />
              </div>
              <div className="h-full lg:w-full lg:h-[30%] p-3 lg:p-2">
                <p className="mt-1 text-h5 text-heading font-semibold text-left leading-none">
                {book.title}
                </p>
                <div className="flex justify-between items-center mt-4">
                  <p className="text-secondary-dark text-p1 font-semibold">
                  {book.Bauthors?.map(
                                      (auther , index , arr) => <span>{
                                        (arr.indexOf(arr[index]) === arr.length -1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                                        }</span>
                                    )}                    </p>
                  {/* <p className="text-heading font-semibold text-p1 text-montserrat">
                    &#8377; {book.eBookPrice}
                  </p> */}
                </div>
              </div>
            </div>)):
            <div className="flex justify-center items-center w-full h-[125px] border-1 border-solid border-primary-dark-20 bg-[#fbfafb] mb-6">
             <h3 className="text-[#383737] font-bold  ">
              No Book found with this title. Please try again...
             </h3>
          </div> }
          </div>
        </div>
      </div>
    </Page>
  );
}
